/** A board has no table to hold row selection, so it keeps a plain set of card ids. */

type LaneSelectionState = `none` | `some` | `all`

/** Picks a card, or puts it back. */
export function toggleId(selected: ReadonlySet<string>, id: string): ReadonlySet<string> {
  const next = new Set(selected)
  if (next.has(id)) next.delete(id)
  else next.add(id)
  return next
}

/** How much of a lane is picked, for the lane's own checkbox. */
export function laneSelectionState(selected: ReadonlySet<string>, laneIds: readonly string[]): LaneSelectionState {
  const picked = laneIds.filter((id) => selected.has(id)).length
  if (picked === 0) return `none`
  return picked === laneIds.length ? `all` : `some`
}

/**
 * Picks the whole lane, or, when all of it is already picked, puts back just that lane.
 * Cards picked in other lanes are untouched either way.
 */
export function toggleLane(selected: ReadonlySet<string>, laneIds: readonly string[]): ReadonlySet<string> {
  const next = new Set(selected)
  if (laneSelectionState(selected, laneIds) === `all`) laneIds.forEach((id) => next.delete(id))
  else laneIds.forEach((id) => next.add(id))
  return next
}

/** Drops picked cards no longer on the board. The same set when nothing went, so a state update bails out. */
export function pruneSelection(selected: ReadonlySet<string>, visibleIds: ReadonlySet<string>): ReadonlySet<string> {
  const kept = [...selected].filter((id) => visibleIds.has(id))
  return kept.length === selected.size ? selected : new Set(kept)
}
